import React from 'react';
import { Icon } from '@olxin/panamera-react-ui';
import cx from 'classnames';
import ImageWrapper from "../../../../Components/ImageWrapper/ImageWrapper";
import { FormattedMessage as Translation } from 'react-intl';
import { populateStringTemplate } from "../../../../Utils/TextHelper";
import CTA from "../../../../Components/CTA/CTA";
import { EVALUATION_STATES_TRACKING, FLOW_TYPES } from "../../../../Constants/evaluation";
var css = {
  "container": "oalp-2dgE6",
  "flexItem1": "oalp-1oo6c",
  "container1": "oalp-31VG3",
  "innerCont1": "oalp-KNNpm",
  "imgIcon": "oalp-FQbZa",
  "insText": "oalp-2W9CS",
  "dateText": "oalp-1-6bJ",
  "innerCont2": "oalp-2HvpX",
  "text1": "oalp-IoYgW",
  "text2": "oalp-1Rp9H",
  "text3": "oalp-k384b",
  "flexItem2": "oalp-2u4TF",
  "rowItem": "oalp-2WIaZ",
  "appointmentText": "oalp-2uKDc",
  "rowSpace": "oalp-1yEBQ",
  "rowValue": "oalp-1OcNg",
  "daysLeft": "oalp-1FL2n",
  "flexItem3": "oalp-romNt"
};
var getDaysLeftComponent = function getDaysLeftComponent(daysLeft) {
  var values = {
    daysLeft: daysLeft
  };
  if (daysLeft == 1) {
    return /*#__PURE__*/React.createElement(Translation, {
      id: "dayLeft",
      values: values
    });
  }
  if (daysLeft > 1) {
    return /*#__PURE__*/React.createElement(Translation, {
      id: "daysLeft",
      values: values
    });
  }
  return null;
};
export var BookingConfirmedL2QDesktop = function BookingConfirmedL2QDesktop(_ref) {
  var _ref$make = _ref.make,
    make = _ref$make === void 0 ? '' : _ref$make,
    _ref$model = _ref.model,
    model = _ref$model === void 0 ? '' : _ref$model,
    _ref$mileage = _ref.mileage,
    mileage = _ref$mileage === void 0 ? '' : _ref$mileage,
    _ref$mobile = _ref.mobile,
    mobile = _ref$mobile === void 0 ? '' : _ref$mobile,
    _ref$daysLeft = _ref.daysLeft,
    daysLeft = _ref$daysLeft === void 0 ? 0 : _ref$daysLeft,
    _ref$typeOfInspection = _ref.typeOfInspection,
    typeOfInspection = _ref$typeOfInspection === void 0 ? '' : _ref$typeOfInspection,
    _ref$date = _ref.date,
    date = _ref$date === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : _ref$date,
    _ref$time = _ref.time,
    time = _ref$time === void 0 ? '' : _ref$time,
    scheduledImage = _ref.scheduledImage,
    _ref$subTitle = _ref.subTitle,
    subTitle = _ref$subTitle === void 0 ? {} : _ref$subTitle,
    image = _ref.image,
    year = _ref.year,
    _ref$subHeading = _ref.subHeading,
    subHeading = _ref$subHeading === void 0 ? {} : _ref$subHeading,
    name = _ref.name,
    bookingId = _ref.bookingId,
    track = _ref.track,
    onTrack = _ref.onTrack,
    locationId = _ref.locationId,
    cta = _ref.cta;
  var _a;
  function buttonJSX() {
    var _a;
    return (_a = cta === null || cta === void 0 ? void 0 : cta.buttons) === null || _a === void 0 ? void 0 : _a.map(function (button, idx) {
      button = Object.assign(Object.assign({}, button), {
        invert: false,
        action: populateStringTemplate(button.action, {
          bookingId: bookingId || ''
        })
      });
      return /*#__PURE__*/React.createElement(CTA, {
        "data-aut-id": "see_details_".concat(idx),
        key: "widget_".concat(name),
        button: button,
        customClass: css.manageBookingCTA,
        widgetKey: name || '',
        track: track,
        onTrack: onTrack,
        locationId: locationId,
        select_from: EVALUATION_STATES_TRACKING.BOOKING_CONFIRMATION,
        flow_type: FLOW_TYPES.NO_DRAFT
      });
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css.container,
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(css.flexItem1)
  }, /*#__PURE__*/React.createElement("div", {
    className: css.container1
  }, /*#__PURE__*/React.createElement("div", {
    className: css.innerCont1
  }, image && /*#__PURE__*/React.createElement(ImageWrapper, {
    id: 'ins icon',
    image: image,
    className: css.imgIcon
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: css.insText
  }, typeOfInspection, " "), /*#__PURE__*/React.createElement("div", {
    className: css.dateText
  }, date))), /*#__PURE__*/React.createElement("div", {
    className: css.innerCont2
  }, /*#__PURE__*/React.createElement("div", {
    className: css.text1
  }, subTitle.text), /*#__PURE__*/React.createElement("div", {
    className: css.text2
  }, make, " ", model, " ", year), /*#__PURE__*/React.createElement("div", {
    className: css.text3
  }, mileage)))), /*#__PURE__*/React.createElement("div", {
    className: cx(css.flexItem2)
  }, /*#__PURE__*/React.createElement("div", {
    className: css.innerCont1
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(css.rowItem, css.appointmentText)
  }, subHeading.text), /*#__PURE__*/React.createElement("div", {
    className: css.rowItem
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "meeting",
    color: "primaryBase",
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.rowSpace)
  }, date), daysLeft > 0 && /*#__PURE__*/React.createElement("span", {
    className: cx(css.rowValue, css.daysLeft)
  }, "| ", getDaysLeftComponent(daysLeft))), /*#__PURE__*/React.createElement("div", {
    className: css.rowItem
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "clock",
    color: "primaryBase",
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.rowSpace)
  }, time)), /*#__PURE__*/React.createElement("div", {
    className: css.rowItem
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "smartphones",
    color: "primaryBase",
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.rowSpace)
  }, mobile)), ((_a = cta === null || cta === void 0 ? void 0 : cta.buttons) === null || _a === void 0 ? void 0 : _a.length) && /*#__PURE__*/React.createElement("div", {
    className: css.rowItem
  }, buttonJSX()))), /*#__PURE__*/React.createElement("div", {
    className: cx(css.flexItem3)
  }, scheduledImage && /*#__PURE__*/React.createElement(ImageWrapper, {
    id: 'schedule ins image',
    className: css.tagImage,
    image: scheduledImage
  })));
};
export default BookingConfirmedL2QDesktop;